<!-- =========================================================================================
  File Name: UserList.vue
  Description: Lists page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      <div class="vx-row p-4" style="float:right!important;">
        <div class="vx-col-12" style="float:right!important;">
          <vs-button color="primary" style="float:right!important;"  type="filled" icon-pack="feather" icon="icon-plus-circle" @click="addListPopUpActive = !addListPopUpActive">{{ $t('MODULES.add') }}</vs-button>
        </div>
      </div>
      <br><br><br>
      <vs-popup :title="$t('MODULES.add_lists')" :active.sync="addListPopUpActive">
        <div class="vx-row" id="add-list">
          <div class="vx-col md:w-1/4 w-full mt-2 mb-3">
            <vs-input :label="$t('MODULES.listName')" v-model="listAddObject.name" class="w-full" type="text" name="block-title"/>
          </div>
          <div class="vx-col md:w-1/4 w-full mt-2 ml-3">
            <label class="vs-input--label">{{ $t('MODULES.orderBy') }}</label>
            <v-select v-model="listAddObject.orderField" class="field-type-select" :clearable="false" :options="orderFields" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="!(orderFields.length > 0)" />
          </div>
          <div class="vx-col md:w-1/4 w-full mt-2 ml-3" v-show="listAddObject.orderField.hasOwnProperty('hash') && listAddObject.orderField['hash'] !== 'newer' && listAddObject.orderField['hash'] !== 'older'">
            <label class="vs-input--label">{{$t('MODULES.sortType') }}</label>
            <v-select v-model="listAddObject.orderType" class="field-type-select" :clearable="true" :options="[{name: 'Ascendente', value: 'ASC'}, {name: 'Descendente', value: 'DESC'}]" label="name" />
          </div>
          <!-- <ul class="switch-container mt-2 ml-3">
            <li>
              <label class="vs-input--label">Compartilhada</label>
              <vs-switch disabled v-model="listAddObject.public" class="mt-1 ml-1" />
            </li>
          </ul> -->
          <!-- <div class="vx-col md:w-1/2 w-full mt-2 ml-3" v-show="!listAddObject.public">
            <label class="vs-input--label">Pertence à</label>
            <v-select v-model="listAddObject.owner" class="field-type-select" :clearable="false" :options="userOptions" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div> -->
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <h6 class="mt-5 mb-3">{{$t('MODULES.moduleFields')}}</h6>
            <draggable :list="addListData.moduleFields" :group="{name:'tags',  pull:'clone', put:false }" class="p-2 cursor-move" @end="onEnd" data-side="left">
              <vs-chip color="primary" style="font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;" :data-hash="listItem.hash" v-for="(listItem, index) in addListData.moduleFields" :key="index"> {{ listItem.name }} </vs-chip>
            </draggable>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <h6 class="mt-5 mb-3">{{ $t('MODULES.listFields') }}</h6>
            <draggable :list="addListData.listFields" :group="{name: 'tags'}" class="p-2 cursor-move" data-side="right">
              <vs-chip color="primary" :class="{'demo-chip': listItem.opacity}" style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;" :data-hash="listItem.hash" v-for="(listItem, index) in addListData.listFields" :key="index"> <feather-icon v-if="!listItem.opacity" icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3" @click="removeItemAdd(index)" style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon> {{ listItem.name }} </vs-chip>
            </draggable>
          </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
              <!-- <div class="mt-8 flex flex-wrap" style="float: left;"> -->
                <vs-button class="ml-auto mt-2" @click="addList">{{$t('MODULES.save')}}</vs-button>
              <!-- </div> -->
            </div>
          </div>
      </vs-popup>

      <vs-popup :title="$t('MODULES.editList')" :active.sync="editListPopUpActive">
        <div class="vx-row" id="add-list" v-if="!($route.params.listHash !== undefined && $route.params.redirectUrl !== undefined)">
          <div class="vx-col md:w-1/4 w-full mt-2 mb-3">
            <vs-input :label="$t('MODULES.listName')" v-model="listEditObject.name" class="w-full" type="text" name="block-title"/>
          </div>
          <div class="vx-col md:w-1/4 w-full mt-2 ml-3">
            <label class="vs-input--label">{{ $t('MODULES.orderBy') }}</label>
            <v-select v-model="listEditObject.orderField" :disabled="!(orderFields.length > 0)" class="field-type-select" :clearable="false" :options="orderFields" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col md:w-1/4 w-full mt-2 ml-3" v-show="listEditObject.orderField.hasOwnProperty('hash') && listEditObject.orderField['hash'] !== 'newer' && listEditObject.orderField['hash'] !== 'older'">
            <label class="vs-input--label">{{ $t('MODULES.sortType') }}</label>
            <v-select v-model="listEditObject.orderType" class="field-type-select" :clearable="true" :options="[{name: 'Ascendente', value: 'ASC'}, {name: 'Descendente', value: 'DESC'}]" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <!-- <ul class="switch-container mt-2 ml-3">
            <li>
              <label class="vs-input--label">Compartilhada</label>
              <vs-switch :disabled="true" v-model="listEditObject.public" class="mt-1 ml-1" />
            </li>
          </ul> -->
          <div class="vx-col md:w-1/2 w-full mt-2 ml-3" v-show="!listEditObject.public">
            <label class="vs-input--label">{{ $t('MODULES.belongsTo') }}</label>
            <v-select v-model="listEditObject.owner" class="field-type-select" :clearable="false" :options="userOptions" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>
        <div class="vx-row" :key="querybuilderKey" v-if="allModuleFields.length > 0 && canShow && JSON.stringify(listFields) !== '{}'">
          <div class="vx-col w-full mt-2 mb-3">
            <h6 class="mt-5 mb-3">{{ $t('MODULES.conditions')}}</h6>
            <ejs-querybuilder ref="querybuilder" width="90%" :rule="ruleData" :ruleChange="updateRule" maxGroupCount="1" :change="queryBuilderChange">
              <e-columns>
                <template v-for="(fieldItem, index) in allModuleFields">
                  <e-column v-if="fieldItem.type === 12 || fieldItem.type === 13" :data-hash="fieldItem.hash" :key="index + Math.random()" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="dateOperators" :template="generateDateTemplate()" format="dd/MM/yyyy"/>
                  <!-- <e-column v-else-if="fieldItem.type === 13" :data-hash="fieldItem.hash" :key="index + Math.random()" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="dateOperators" format="dd/MM/yyyy HH:mm:ss"/> -->
                  <e-column v-else-if="fieldItem.type === 2" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="integerOperators" />
                  <e-column v-else-if="fieldItem.type === 16" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="integerOperators" />
                  <e-column v-else-if="fieldItem.type === 18" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="integerOperators" />
                  <e-column v-else-if="fieldItem.type === 20" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="integerOperators"/>
                  <e-column v-else-if="fieldItem.type === 23" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="[{key: 'Igual', value: 'equal'}]" :values="['Verdadeiro', 'Falso']"/>
                  <e-column v-else-if="fieldItem.type === 24 && !fieldItem.core" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="listOperators" :template="generateListTemplate()"/>
                  <e-column v-else-if="fieldItem.type === 24 && fieldItem.core" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="assignedToOperators" :template="generateListTemplate()"/>
                  <e-column v-else-if="fieldItem.type === 29" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="listOperators" :template="generateListTemplate()"/>
                  <e-column v-else-if="fieldItem.type === 25" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="'string'" :operators="listOperators" :template="generateListTemplate()"/>
                  <e-column v-else-if="fieldItem.type === 30" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="listOperators" :template="generateListTemplate()"/>
                  <e-column v-else-if="fieldItem.name === 'Hash'" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="hashOperators"/>
                  <e-column v-else-if="fieldItem.name === 'Identifier'" :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="identifierOperators"/>
                  <e-column v-else :data-hash="fieldItem.hash" :field="fieldItem.hash" :label="fieldItem.name" :type="typeCast[fieldItem.type]" :operators="stringOperators"/>
                </template>
                <!-- <e-column :field="'24f9ac41-b962-473a-96d0-77de23ed3bd4'" :label="'Nome'" :type="'string'" :operators="stringOperators"/>
                <e-column :field="'450a8e54-c992-4b71-bd61-943cfb3c3730'" :label="'Lista'" :type="'string'" :operators="listOperators" :template="listTemplate"/> -->
              </e-columns>
            </ejs-querybuilder>
          </div>
        </div>
        <div class="vx-row" v-if="!($route.params.listHash !== undefined && $route.params.redirectUrl !== undefined)">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <h6 class="mt-5 mb-3">{{ $t('MODULES.moduleFields') }}</h6>
            <draggable :list="editListData.moduleFields" :group="{name:'tags',  pull:'clone', put:false }" class="p-2 cursor-move" @end="onEndEdit" data-side="left">
              <vs-chip color="primary" style="font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;" :data-hash="listItem.hash" v-for="(listItem, index) in editListData.moduleFields" :key="index"> {{ listItem.name }} </vs-chip>
            </draggable>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <h6 class="mt-5 mb-3">{{ $t('MODULES.listFields') }}</h6>
            <draggable :list="editListData.listFields" :group="{name: 'tags'}" class="p-2 cursor-move" data-side="right">
              <vs-chip color="primary" :class="{'demo-chip': listItem.opacity}" style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;" :data-hash="listItem.hash" v-for="(listItem, index) in editListData.listFields" :key="index"> <feather-icon v-if="!listItem.opacity" icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3" @click="removeItemEdit(index)" style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon> {{ listItem.name }} </vs-chip>
            </draggable>
          </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
              <!-- <div class="mt-8 flex flex-wrap" style="float: left;"> -->
                <vs-button class="ml-auto mt-2" @click="updateList">{{ $t('MODULES.save') }}</vs-button>
              <!-- </div> -->
            </div>
          </div>
      </vs-popup>
      <div class="vx-card p-6">
        <vs-table
        multiple
        v-model="selectedRows"
        :sst="false"
        @search="handleSearch"
        @change-page="handleChangePage"
        @sort="handleSort"
        pagination
        max-items="10"
        search
        :data="lists">

          <template slot="header">
              <h3>{{ $t('MODULES.lists') }}</h3>
          </template>

          <template slot="thead">
              <vs-th sort-key="hash">{{$t('MODULES.hash')}}</vs-th>
              <vs-th sort-key="name">{{$t('MODULES.name')}}</vs-th>
              <vs-th sort-key="created_at">{{$t('MODULES.default')}}</vs-th>
              <!-- <vs-th sort-key="type">{{$t('MODULES.shared')}}</vs-th> -->
              <vs-th sort-key="session_type">{{$t('MODULES.createdBy')}}</vs-th>
              <!-- <vs-th sort-key="session_type">{{$t('MODULES.belongsTo')}}</vs-th> -->
              <vs-th sort-key="actions">{{$t('MODULES.actions')}}</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].hash">
                {{ data[indextr].hash }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>

              <vs-td :data="data[indextr].core">
                {{ data[indextr].core ? 'Sim' : 'Não' }}
              </vs-td>

              <!-- <vs-td :data="data[indextr].public">
                {{ data[indextr].public ? 'Sim' : 'Não'}}
              </vs-td> -->

              <vs-td :data="data[indextr].created_by">
                {{ data[indextr].created_by ? data[indextr].created_by.name : ' - ' }}
              </vs-td>

              <!-- <vs-td :data="data[indextr].owner">
                {{ data[indextr].owner ? data[indextr].owner.name : ' - '}}
              </vs-td> -->

              <!-- <vs-td>
                <vs-chip :color="colors[indextr]" class="product-order-status">{{ labels[indextr] }}</vs-chip>
              </vs-td> -->
              <vs-td>
                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="getListDetail(data[indextr]['hash'])"/>
                <feather-icon v-if="!data[indextr]['core']" icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr]['hash'])"/>
              </vs-td>
            </vs-tr>
          </template>
      </vs-table>
      </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import draggable from 'vuedraggable'
import { DropDownList } from '@syncfusion/ej2-dropdowns'
import { DatePicker } from '@syncfusion/ej2-calendars'
import { createElement, getComponent } from '@syncfusion/ej2-base'
import { setApplicationLocalStorageItem, performFetch } from '../../../helpers'
// import StringMask from 'string-mask'
export default {

  data () {
    return {
      querybuilderKey: 0,
      values: ['Mr.', 'Mrs.'],
      dataSource: [],
      ruleDataTemp: null,
      canShow: false,
      ruleData: {
        'condition': 'and',
        'rules': []
      },
      hasRuleData: false,
      listTemplate: {
        create: () => {
          return createElement('input', { attrs: { 'type': 'text' } })
        },
        destroy: (args) => {
          try {
            const dropdownlist = getComponent(document.getElementById(args.elementId), 'dropdownlist')
            if (dropdownlist) dropdownlist.destroy()
          } catch (e) {
            //
          }
        },
        write: (args) => {
          const ds = this.listFields[args.field]

          const new_ds = []

          ds.forEach((item) => {
            new_ds.push({text: item.label, value: item.value})
          })

          const dropDownObj = new DropDownList({
            dataSource: new_ds,
            value: args.values,
            change: (e) => {
              console.log(e)
              // console.log(e.itemData.value, e.element)
              this.$refs.querybuilder.ej2Instances.notifyChange(e.itemData.value, e.element)
            }
          })
          dropDownObj.appendTo(`#${  args.elements.id}`)
        }
      },
      listFields: {},
      dateFields: [],
      datetimeFields: [],
      dateOperators: [
        {key: 'Igual', value: 'equal'},
        { key: 'Diferente', value: 'notequal' },
        { key: 'Maior que', value: 'greaterthan' },
        { key: 'Menor que', value: 'lessthan' },
        { key: 'Menor ou igual à', value: 'lessthanorequal' },
        { key: 'Maior ou igual à', value: 'greaterthanorequal' },
        { key: 'Vazio', value: 'isempty'},
        { key: 'Não vazio', value: 'notnull'},
        { key: 'Customizado', value: 'customized'}
      ],
      integerOperators: [
        { key: this.$t('MODULES.OPERATORS.equal'), value: 'equal' },
        { key: this.$t('MODULES.OPERATORS.notequal'), value: 'notequal' },
        { key: this.$t('MODULES.OPERATORS.greaterthan'), value: 'greaterthan' },
        { key: this.$t('MODULES.OPERATORS.lessthan'), value: 'lessthan' },
        { key: this.$t('MODULES.OPERATORS.lessthanorequal'), value: 'lessthanorequal' },
        { key: this.$t('MODULES.OPERATORS.greaterthanorequal'), value: 'greaterthanorequal' },
        { key: this.$t('MODULES.OPERATORS.between'), value: 'between' },
        { key: this.$t('MODULES.OPERATORS.notbetween'), value: 'notbetween' },
        { key: this.$t('MODULES.OPERATORS.in'), value: 'in' },
        { key: this.$t('MODULES.OPERATORS.notin'), value: 'notin' },
        { key: this.$t('MODULES.OPERATORS.isempty'), value: 'isempty' },
        { key: this.$t('MODULES.OPERATORS.notnull'), value: 'notnull' }
      ],
      stringOperators: [
        { key: this.$t('MODULES.OPERATORS.startswith'), value: 'startswith' },
        { key: this.$t('MODULES.OPERATORS.endswith'), value: 'endswith' },
        { key: this.$t('MODULES.OPERATORS.contains'), value: 'contains' },
        { key: this.$t('MODULES.OPERATORS.equal'), value: 'equal' },
        { key: this.$t('MODULES.OPERATORS.notequal'), value: 'notequal' },
        { key: this.$t('MODULES.OPERATORS.isempty'), value: 'isempty' },
        { key: this.$t('MODULES.OPERATORS.isnotempty'), value: 'isnotempty' }
      ],
      hashOperators: [
        { value: 'equal', key: this.$t('MODULES.OPERATORS.equal') },
        { value: 'notequal', key: this.$t('MODULES.OPERATORS.notequal') }
      ],
      identifierOperators: [
        { key: this.$t('MODULES.OPERATORS.equal'), value: 'equal' },
        { key: this.$t('MODULES.OPERATORS.notequal'), value: 'notequal' },
        { key: this.$t('MODULES.OPERATORS.contains'), value: 'contains' }
      ],
      assignedToOperators: [
        { key: this.$t('MODULES.OPERATORS.equal'), value: 'equal' },
        { key: this.$t('MODULES.OPERATORS.notequal'), value: 'notequal' }
      ],
      listOperators: [
        { key: this.$t('MODULES.OPERATORS.equal'), value: 'equal' },
        { key: this.$t('MODULES.OPERATORS.notequal'), value: 'notequal' },
        { key: this.$t('MODULES.OPERATORS.isempty'), value: 'isempty' },
        { key: this.$t('MODULES.OPERATORS.isnotempty'), value: 'isnotempty' }


      ],
      typeCast: {
        1: 'string',
        2: 'number',
        3: 'string',
        4: 'string',
        5: 'string',
        6: 'string',
        7: 'string',
        8: 'string',
        9: 'string',
        10: 'string',
        11: 'string',
        12: 'date',
        13: 'date',
        14: 'string',
        15: 'string',
        16: 'number',
        17: 'string',
        18: 'number',
        19: 'string',
        20: 'number',
        21: 'none',
        22: 'none',
        23: 'boolean',
        24: 'string',
        25: 'string',
        29: 'string',
        30: 'string'
      },
      booleanValues: ['Verdadeiro', 'Falso'],
      moduleFieldsOriginalLength: 0,
      addListData: {
        moduleFields: [],
        listFields: [{hash: 0, name: this.$t('MODULES.dragItem'), opacity: true}]
      },
      listAddObject: {
        name: '',
        public: true,
        owner: {},
        orderField: {}
      },
      editListData: {
        moduleFields: [],
        listFields: [{hash: 0, name: this.$t('MODULES.dragItem'), opacity: true}]
      },
      listEditObject: {
        hash: '',
        name: '',
        public: true,
        owner: {},
        orderField: {}
      },
      hasDateFields: false,
      hasDatetimeFields: false,
      addListPopUpActive: false,
      editListPopUpActive: false,
      selected:[],
      log: [],
      moduleFields: [],
      allModuleFields: [],
      allModuleFieldsTemp: [],
      modules: [],
      lists: [],
      tableTitles: [],
      selectedRows: [],
      rowHashToDelete: '',
      listFieldsObject: {},
      userOptions: [],
      orderFields: [],
      fieldTypesObject: {},
      customDateTemplateValues: ['today', 'previous_day', 'day_before_yesterday', 'last_two_days', 'last_seven_days', 'last_fifteen_days', 'last_thirty_days', 'last_ninety_days', 'last_year']
    }
  },
  components: {
    vSelect,
    draggable
  },
  watch: {
    '$route.params.listHash' (value) {
      this.getListDetail(value)
    },
    selectedRows (value) {
      //
    },
    'addListData.listFields' (value) {
      if (!(value.length === 1 && value[value.length - 1].hash === 0)) {
        const findFieldIndex = value.findIndex((item) => item.hash === 0)

        if (findFieldIndex > -1) {
          this.addListData.listFields.splice(findFieldIndex, 1)
        }

        const findModuleFieldIndex = this.addListData.moduleFields.findIndex((item) => item.hash === value.hash)

        if (findModuleFieldIndex > -1) {
          this.addListData.moduleFields.splice(findModuleFieldIndex, 1)
        }

        this.orderFields = JSON.parse(JSON.stringify(this.addListData.listFields))

        this.orderFields.unshift({
          name: this.$t('MODULES.mostRecentRecord'),
          hash: 'newer'
        })

        this.orderFields.unshift({
          name: this.$t('MODULES.oldestRecord'),
          hash: 'older'
        })

        const hashIndex = this.orderFields.findIndex(x => x.name === 'Hash')

        if (hashIndex > 0) {
          this.orderFields.splice(hashIndex, 1)
        }

        const fieldsToRemoveIndexes = []

        this.orderFields.forEach((item, index) => {
          if ([21, 22, 27, 28, 30, 31, 32, 33].includes(item.type)) {
            fieldsToRemoveIndexes.push(index)
          }
        })

        fieldsToRemoveIndexes.sort(function (a, b) { return b - a })

        for (const i of fieldsToRemoveIndexes) {
          this.orderFields.splice(i, 1)
        }

      }
    },
    addListPopUpActive (value) {
      if (!value) {
        this.orderFields = []
      }
    },
    editListPopUpActive (value) {
      if (!value) {
        // this.$vs.loading({type: 'default'})
        if (this.$route.params.listHash !== undefined && this.$route.params.redirectUrl !== undefined) {
          setTimeout(() => {
            const redirectUrl = atob(this.$route.params.redirectUrl)
            this.$router.push(`/${  redirectUrl}`).catch()
          }, 300)
        } else {
          this.querybuilderKey += 1
        }

        this.orderFields = []
      }
    },
    'editListData.listFields' (value) {
      if (!(value.length === 1 && value[value.length - 1].hash === 0)) {

        this.orderFields = []

        const findFieldIndex = value.findIndex((item) => item.hash === 0)

        if (findFieldIndex > -1) {
          this.editListData.listFields.splice(findFieldIndex, 1)
        }

        const findModuleFieldIndex = this.addListData.moduleFields.findIndex((item) => item.hash === value.hash)

        if (findModuleFieldIndex > -1) {
          this.editListData.moduleFields.splice(findModuleFieldIndex, 1)
        }

        this.orderFields = JSON.parse(JSON.stringify(this.editListData.listFields))

        this.orderFields.unshift({
          name: this.$t('MODULES.mostRecentRecord'),
          hash: 'newer'
        })

        this.orderFields.unshift({
          name: this.$t('MODULES.oldestRecord'),
          hash: 'older'
        })

        const hashIndex = this.orderFields.findIndex(x => x.name === 'Hash')

        if (hashIndex > 0) {
          this.orderFields.splice(hashIndex, 1)
        }

        const fieldsToRemoveIndexes = []

        this.orderFields.forEach((item, index) => {
          if (item.hash !== 'newer' && item.hash !== 'older') {
            const fieldObject = this.allModuleFields.find(x => x.hash === item.hash)
            if ([21, 22, 27, 28, 30, 31, 32, 33].includes(fieldObject.type)) {
              fieldsToRemoveIndexes.push(index)
            }
          }
        })

        fieldsToRemoveIndexes.sort(function (a, b) { return b - a })

        for (const i of fieldsToRemoveIndexes) {
          this.orderFields.splice(i, 1)
        }

      }
    }
  },
  mounted () {
    document.querySelector('.vx-card').style.backgroundColor = '#fff'
    document.title = `${document.title.split(' | ')[0]  } | Módulos`

    document.querySelectorAll('.con-vs-popup > .vs-popup').forEach(item => {
      item.style.width = '1200px'
    })
  },
  methods:{
    generateDateTemplate () {
      return {
        create: () => {
          return createElement('input', { attrs: { 'type': 'text' } })
        },
        destroy: (args) => {
          try {
            const component = getComponent(document.getElementById(args.elementId), 'dropdownlist') ||
                            getComponent(document.getElementById(args.elementId), 'datepicker')
            if (component) component.destroy()
          } catch (e) {
            //
          }
        },
        write: (args) => {
          if (args.operator === 'customized') {
            const ds = [
              {text: this.$t('MODULES.today'), value: 'today' },
              {text: this.$t('MODULES.previousDay'), value: 'previous_day' },
              {text: this.$t('MODULES.dayBeforeYesterday'), value: 'day_before_yesterday'},
              {text: this.$t('MODULES.lastTwoDays'), value: 'last_two_days'},
              {text: this.$t('MODULES.lastSevenDays'), value: 'last_seven_days'},
              {text: this.$t('MODULES.lastFifteenDays'), value: 'last_fifteen_days'},
              {text: this.$t('MODULES.lastThirtyDays'), value: 'last_thirty_days'},
              {text: this.$t('MODULES.lastNinetyDays'), value: 'last_ninety_days'},
              {text: this.$t('MODULES.lastYear'), value: 'last_year'}
            ]

            let value = null

            if (args.values) {
              value = ds.find(x => x.value === args.values).text
            }

            const dropDownObj = new DropDownList({
              dataSource: ds,
              value,
              change: (e) => {
                console.log(e)
                this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(e.itemData.value, e.element)
              }
            })
            dropDownObj.appendTo(`#${  args.elements.id}`)
          } else {
            const datePickerObj = new DatePicker({
              value: args.values,
              change: (e) => {
                console.log(e)
                this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(e.value, e.element)
              },
              format: 'dd/MM/yyyy'
            })
            datePickerObj.appendTo(`#${  args.elements.id}`)
          }
        }
      }
    },
    generateListTemplate () {
      return {
        create: () => {
          return createElement('input', { attrs: { 'type': 'text' } })
        },
        destroy: (args) => {
          try {
            const dropdownlist = getComponent(document.getElementById(args.elementId), 'dropdownlist')
            if (dropdownlist) dropdownlist.destroy()
          } catch (e) {
            //
          }
        },
        write: (args) => {
          const ds = this.listFields[args.field]

          const new_ds = []

          ds.forEach((item) => {
            new_ds.push({text: item.label, value: item.value})
          })

          const dropDownObj = new DropDownList({
            dataSource: new_ds,
            value: args.values,
            change: (e) => {
              // console.log(e)
              // console.log(e.itemData.value, e.element)
              // this.$refs.querybuilder.ej2Instances.notifyChange(e.itemData.value, e.element)
              // console.log(this.$refs.querybuilder.$el.ej2_instances)
              this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(e.itemData.value, e.element)
            }
          })
          dropDownObj.appendTo(`#${  args.elements.id}`)
        }
      }
    },
    queryBuilderChange (e) {
      // console.log(e)
    },
    async isUuid (value) {
      const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      return regex.test(value)
    },
    async convertListValues () {

      for (const row of this.ruleData.rules) {
        const fieldType = this.fieldTypesObject[row.field]

        if (fieldType === 24 || fieldType === 25) {
          const isUuid = await this.isUuid(row.value)
          if (!isUuid) {

            const rowIndex = this.ruleData.rules.findIndex(x => x.field === row.field)

            const fieldValue = this.listFields[row.field].find(x => x.label === row['value']).value

            if (rowIndex > -1) {
              this.ruleData.rules[rowIndex].value = fieldValue
            }
          }
        }
      }
    },
    async setListValues () {
      // this.$refs.querybuilder.ej2Instances.notifyChange(e.itemData.value, e.element)

      // Object.keys(this.listFields).forEach(item => {
      //   console.log(this.listFields[item])
      // })

      const listFieldsList = []

      for (let i = 0; i < Object.keys(this.listFields).length; i++) {
        listFieldsList.push(Object.keys(this.listFields)[i])
      }

      if (this.ruleDataTemp.hasOwnProperty('rules') && this.ruleDataTemp.rules.length > 0) {

        const hashItems = this.ruleDataTemp.rules.filter(x => x.field === 'Hash')

        if (hashItems.length > 0) {

          const validateHashs = await this.validateHashItems(hashItems)

          if (!validateHashs) {
            this.$vs.notify({
              title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('MODULES.hashInvalidText'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          } else {
            // var findGroup = this.ruleData.rules.find(x => console.log(x))
            let findGroup = this.ruleDataTemp.rules.find(x => x.hasOwnProperty('rules'))

            if (findGroup !== undefined) {
              if (findGroup.hasOwnProperty('rules') && findGroup.rules.length > 0) {

                const hashItems = findGroup.rules.filter(x => x.label === 'Hash')

                if (hashItems.length > 0) {

                  const validateHashs = await this.validateHashItems(hashItems)

                  if (!validateHashs) {
                    this.$vs.notify({
                      title: this.$t('MODULES.hashInvalidTitle'),
                      text: this.$t('MODULES.hashInvalidText'),
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'warning'
                    })

                    return false
                  } else {
                    findGroup = findGroup.rules.find(x => x.hasOwnProperty('rules'))

                    if (findGroup !== undefined) {
                      if (findGroup.hasOwnProperty('rules') && findGroup.rules.length > 0) {

                        const hashItems = findGroup.rules.filter(x => x.label === 'Hash')

                        if (hashItems.length > 0) {

                          const validateHashs = await this.validateHashItems(hashItems)

                          if (!validateHashs) {
                            this.$vs.notify({
                              title: this.$t('MODULES.hashInvalidTitle'),
                              text: this.$t('MODULES.hashInvalidText'),
                              iconPack: 'feather',
                              icon: 'icon-alert-circle',
                              color: 'warning'
                            })

                            return false
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    revertDate () {
      if (this.dateFields.length > 0) {
        if (this.ruleDataTemp !== null) {
          this.ruleDataTemp.rules.forEach((itemLevel0, indexLevel0) => {
            if (itemLevel0.hasOwnProperty('rules')) {
              itemLevel0.rules.forEach((itemLevel1, indexLevel1) => {
                if (itemLevel1.hasOwnProperty('rules')) {
                  itemLevel1.rules.forEach((itemLevel2, indexLevel2) => {
                    if (this.dateFields.includes(itemLevel2.field)) {
                      if (itemLevel2.value !== null && itemLevel2.value !== '' && !this.customDateTemplateValues.includes(itemLevel2.value)) {
                        const day = itemLevel2.value.split('-')[0]
                        const month = itemLevel2.value.split('-')[1]
                        const year = itemLevel2.value.split('-')[2]

                        this.ruleDataTemp.rules[indexLevel0]['rules'][indexLevel1]['rules'][indexLevel2]['value'] = `${year}/${month}/${day}`
                      }
                    }
                  })
                } else if (this.dateFields.includes(itemLevel1.field)) {
                  if (itemLevel1.value !== null && itemLevel1.value !== '' && !this.customDateTemplateValues.includes(itemLevel1.value)) {
                    const day = itemLevel1.value.split('-')[0]
                    const month = itemLevel1.value.split('-')[1]
                    const year = itemLevel1.value.split('-')[2]

                    this.ruleDataTemp.rules[indexLevel0]['rules'][indexLevel1]['value'] = `${year}/${month}/${day}`
                  }
                }
              })
            } else if (this.dateFields.includes(itemLevel0.field)) {
              if (itemLevel0.value !== null && itemLevel0.value !== '' && !this.customDateTemplateValues.includes(itemLevel0.value)) {
                const day = itemLevel0.value.split('-')[0]
                const month = itemLevel0.value.split('-')[1]
                const year = itemLevel0.value.split('-')[2]

                this.ruleDataTemp.rules[indexLevel0]['value'] = `${year}/${month}/${day}`
              }
            }
          })
        }
      }
    },
    formatDateToSave () {
      if (this.dateFields.length > 0) {
        if (this.ruleData !== null && this.ruleData.hasOwnProperty('rules')) {
          this.ruleData.rules.forEach((itemLevel0, indexLevel0) => {
            if (itemLevel0.hasOwnProperty('rules')) {
              itemLevel0.rules.forEach((itemLevel1, indexLevel1) => {
                if (itemLevel1.hasOwnProperty('rules')) {
                  itemLevel1.rules.forEach((itemLevel2, indexLevel2) => {
                    if (this.dateFields.includes(itemLevel2.field)) {
                      if (itemLevel2.value !== null && itemLevel2.value !== '') {
                        let __value = null
                        if (!this.customDateTemplateValues.includes(itemLevel2.value)) {
                          const day = itemLevel2.value.split('/')[0]
                          const month = itemLevel2.value.split('/')[1]
                          const year = itemLevel2.value.split('/')[2]

                          __value = `${year}-${month}-${day}`
                        } else {
                          __value = itemLevel2.value
                        }

                        this.ruleData.rules[indexLevel0]['rules'][indexLevel1]['rules'][indexLevel2]['value'] = __value
                      }
                    }
                  })
                } else if (this.dateFields.includes(itemLevel1.field)) {
                  if (itemLevel1.value !== null && itemLevel1.value !== '') {
                    let __value = null

                    if (!this.customDateTemplateValues.includes(itemLevel1.value)) {
                      const day = itemLevel1.value.split('/')[0]
                      const month = itemLevel1.value.split('/')[1]
                      const year = itemLevel1.value.split('/')[2]

                      __value = `${year}-${month}-${day}`
                    } else {
                      __value = itemLevel1.value
                    }

                    this.ruleData.rules[indexLevel0]['rules'][indexLevel1]['value'] = __value
                  }
                }
              })
            } else if (this.dateFields.includes(itemLevel0.field)) {
              if (itemLevel0.value !== null && itemLevel0.value !== '') {
                let __value = null

                if (!this.customDateTemplateValues.includes(itemLevel0.value)) {
                  const day = itemLevel0.value.split('/')[0]
                  const month = itemLevel0.value.split('/')[1]
                  const year = itemLevel0.value.split('/')[2]

                  __value = `${year}-${month}-${day}`
                } else {
                  __value = itemLevel0.value
                }

                this.ruleData.rules[indexLevel0]['value'] = __value
              }
            }
          })
        }
      }
    },
    convertDateUtcToBr (date) {
      const day = date.split('-')[2]
      const month = date.split('-')[1]
      const year = date.split('-')[0]

      return `${day}/${month}/${year}`
    },
    convertDatetimeUtcToBr (datetime) {

      const date = datetime.split(' ')[0].trim()
      const time = datetime.split(' ')[1].trim()

      const day = date.split('-')[2]
      const month = date.split('-')[1]
      const year = date.split('-')[0]


      return `${day}/${month}/${year} ${time}`
    },
    revertDatetime () {
      if (this.datetimeFields.length > 0) {
        if (this.ruleDataTemp !== null) {
          this.ruleDataTemp.rules.forEach((itemLevel0, indexLevel0) => {
            if (itemLevel0.hasOwnProperty('rules')) {
              itemLevel0.rules.forEach((itemLevel1, indexLevel1) => {
                if (itemLevel1.hasOwnProperty('rules')) {
                  itemLevel1.rules.forEach((itemLevel2, indexLevel2) => {
                    if (this.datetimeFields.includes(itemLevel2.field)) {

                      if (itemLevel2.value !== null && itemLevel2.value !== '' && itemLevel2.value !== undefined && !this.customDateTemplateValues.includes(itemLevel2.value)) {
                        if (itemLevel2.value.split(' ').length > 1) {
                          this.ruleDataTemp.rules[indexLevel0]['rules'][indexLevel1]['rules'][indexLevel2]['value'] = this.convertDatetimeUtcToBr(this.ruleDataTemp.rules[indexLevel0]['rules'][indexLevel1]['rules'][indexLevel2]['value'])
                        }
                      }

                    }
                  })
                } else if (this.datetimeFields.includes(itemLevel1.field)) {
                  if (itemLevel1.value !== null && itemLevel1.value !== '' && itemLevel1.value !== undefined && !this.customDateTemplateValues.includes(itemLevel1.value)) {
                    if (itemLevel1.value.split(' ').length > 1) {
                      this.ruleDataTemp.rules[indexLevel0]['rules'][indexLevel1]['value'] = this.convertDatetimeUtcToBr(this.ruleDataTemp.rules[indexLevel0]['rules'][indexLevel1]['value'])
                    }
                  }
                }
              })
            } else if (this.datetimeFields.includes(itemLevel0.field)) {

              if (itemLevel0.value !== null && itemLevel0.value !== '' && itemLevel0.value !== undefined && !this.customDateTemplateValues.includes(itemLevel0.value)) {
                if (itemLevel0.value.split(' ').length > 1) {
                  this.ruleDataTemp.rules[indexLevel0]['value'] = this.convertDatetimeUtcToBr(this.ruleDataTemp.rules[indexLevel0]['value'])
                }
              }
            }
          })
        }
      }
    },
// <<<<<<< HEAD
//     formatDatetimeToSave () {
//       if (this.datetimeFields.length > 0) {
//         if (this.ruleData !== null && this.ruleData.hasOwnProperty('rules')) {
//           this.ruleData.rules.forEach((itemLevel0, indexLevel0) => {
//             if (itemLevel0.hasOwnProperty('rules')) {
// =======
//     formatDatetimeToSave() {
//       if(this.datetimeFields.length > 0) {
//         if(this.ruleData !== null && this.ruleData.hasOwnProperty('rules')) {

//           this.ruleData.rules.forEach((itemLevel0, indexLevel0) => {

//             if(itemLevel0.hasOwnProperty('rules')) {
// >>>>>>> master
//               itemLevel0.rules.forEach((itemLevel1, indexLevel1) => {
//                 if (itemLevel1.hasOwnProperty('rules')) {
//                   itemLevel1.rules.forEach((itemLevel2, indexLevel2) => {
//                     if (this.datetimeFields.includes(itemLevel2.field)) {

//                       if (itemLevel2.value !== null && itemLevel2.value !== '' && itemLevel2.value !== undefined) {
//                         let __value = itemLevel2.value
//                         if (!this.customDateTemplateValues.includes(itemLevel2.value)) {
//                           if (itemLevel2.value.split(' ').length > 1) {
//                             const date = itemLevel2.value.split(' ')[0].trim()
//                             const time = itemLevel2.value.split(' ')[1].trim()

//                             const day = date.split('/')[0]
//                             const month = date.split('/')[1]
//                             const year = date.split('/')[2]

//                             __value = `${year}-${month}-${day} ${time}`
//                           }
//                         }

//                         this.ruleData.rules[indexLevel0]['rules'][indexLevel1]['rules'][indexLevel2]['value'] = __value
//                       }

//                     }
//                   })
// <<<<<<< HEAD
//                 } else if (this.datetimeFields.includes(itemLevel1.field)) {
//                   if (itemLevel1.value !== null && itemLevel1.value !== '' && itemLevel1.value !== undefined) {
//                     let __value = itemLevel1.value
// =======
//                 } else {

//                   if(this.datetimeFields.includes(itemLevel1.field)) {
//                     if(itemLevel1.value !== null && itemLevel1.value !== '' && itemLevel1.value !== undefined) {
//                       let __value = itemLevel1.value
// >>>>>>> master

//                     if (!this.customDateTemplateValues.includes(itemLevel1.value)) {
//                       if (itemLevel1.value.split(' ').length > 1) {
//                         const date = itemLevel1.value.split(' ')[0].trim()
//                         const time = itemLevel1.value.split(' ')[1].trim()

//                         const day = date.split('/')[0]
//                         const month = date.split('/')[1]
//                         const year = date.split('/')[2]

//                         __value = `${year}-${month}-${day} ${time}`
//                       }

//                     }

//                     this.ruleData.rules[indexLevel0]['rules'][indexLevel1]['value'] = __value
//                   }
//                 }
//               })
//             } else if (this.datetimeFields.includes(itemLevel0.field)) {

//               if (itemLevel0.value !== null && itemLevel0.value !== '' && itemLevel0.value !== undefined) {
//                 let __value = itemLevel0.value

// <<<<<<< HEAD
//                 if (!this.customDateTemplateValues.includes(itemLevel1.value)) {
//                   if (itemLevel0.value.split(' ').length > 1) {
//                     const date = itemLevel0.value.split(' ')[0].trim()
//                     const time = itemLevel0.value.split(' ')[1].trim()
// =======
//                   if (!this.customDateTemplateValues.includes(itemLevel0.value)) {
//                     if(itemLevel0.value.split(' ').length > 1) {
//                       let date = itemLevel0.value.split(' ')[0].trim()
//                       let time = itemLevel0.value.split(' ')[1].trim()
// >>>>>>> master

//                     const day = date.split('/')[0]
//                     const month = date.split('/')[1]
//                     const year = date.split('/')[2]

//                     __value = `${year}-${month}-${day} ${time}`
//                   }
//                 }

//                 this.ruleData.rules[indexLevel0]['value'] = __value
//               }


//             }

//           })

//         }
//       }
//     },
formatDatetimeToSave() {
      if(this.datetimeFields.length > 0) {
        if(this.ruleData !== null && this.ruleData.hasOwnProperty('rules')) {

          this.ruleData.rules.forEach((itemLevel0, indexLevel0) => {

            if(itemLevel0.hasOwnProperty('rules')) {
              itemLevel0.rules.forEach((itemLevel1, indexLevel1) => {
                if(itemLevel1.hasOwnProperty('rules')) {
                  itemLevel1.rules.forEach((itemLevel2, indexLevel2) => {
                    if(this.datetimeFields.includes(itemLevel2.field)) {

                      if(itemLevel2.value !== null && itemLevel2.value !== '' && itemLevel2.value !== undefined) {
                        let __value = itemLevel2.value
                        if (!this.customDateTemplateValues.includes(itemLevel2.value)) {
                          if(itemLevel2.value.split(' ').length > 1) {
                            let date = itemLevel2.value.split(' ')[0].trim()
                            let time = itemLevel2.value.split(' ')[1].trim()

                            let day = date.split('/')[0]
                            let month = date.split('/')[1]
                            let year = date.split('/')[2]

                            __value = `${year}-${month}-${day} ${time}`
                          }
                        }

                        this.ruleData.rules[indexLevel0]['rules'][indexLevel1]['rules'][indexLevel2]['value'] = __value
                      }

                    }
                  })
                } else {

                  if(this.datetimeFields.includes(itemLevel1.field)) {
                    if(itemLevel1.value !== null && itemLevel1.value !== '' && itemLevel1.value !== undefined) {
                      let __value = itemLevel1.value

                      if (!this.customDateTemplateValues.includes(itemLevel1.value)) {
                        if(itemLevel1.value.split(' ').length > 1) {
                          let date = itemLevel1.value.split(' ')[0].trim()
                          let time = itemLevel1.value.split(' ')[1].trim()

                          let day = date.split('/')[0]
                          let month = date.split('/')[1]
                          let year = date.split('/')[2]

                          __value = `${year}-${month}-${day} ${time}`
                        }

                      }

                      this.ruleData.rules[indexLevel0]['rules'][indexLevel1]['value'] = __value
                    }
                  }
                }
              })
            } else {
              if(this.datetimeFields.includes(itemLevel0.field)) {

                if(itemLevel0.value !== null && itemLevel0.value !== '' && itemLevel0.value !== undefined) {
                  let __value = itemLevel0.value

                  if (!this.customDateTemplateValues.includes(itemLevel0.value)) {
                    if(itemLevel0.value.split(' ').length > 1) {
                      let date = itemLevel0.value.split(' ')[0].trim()
                      let time = itemLevel0.value.split(' ')[1].trim()

                      let day = date.split('/')[0]
                      let month = date.split('/')[1]
                      let year = date.split('/')[2]

                      __value = `${year}-${month}-${day} ${time}`
                    }
                  }

                  this.ruleData.rules[indexLevel0]['value'] = __value
                }

                return
              }
            }

          })

        }
      }
    },
    changeListHashToListValue () {

      try {

        if (this.ruleDataTemp !== null) {
          this.ruleDataTemp.rules.forEach((itemLevel0, indexLevel0) => {

            if (itemLevel0.hasOwnProperty('rules')) {
              itemLevel0.rules.forEach((itemLevel1, indexLevel1) => {
                if (itemLevel1.hasOwnProperty('rules')) {
                  itemLevel1.rules.forEach((itemLevel2, indexLevel2) => {
                    if (itemLevel2.hasOwnProperty('rules')) {
                      itemLevel2.rules.forEach((itemLevel3, indexLevel3) => {
                        if (itemLevel3.hasOwnProperty('rules')) {
                          itemLevel3.rules.forEach((itemLevel4, indexLevel4) => {
                            if (itemLevel4.hasOwnProperty('rules')) {
                              itemLevel4.forEach((itemLevel5, indexLevel5) => {
                                if (itemLevel5.hasOwnProperty('rules')) {
                                  itemLevel5.rules.forEach((itemLevel6, indexLevel6) => {
                                    if (this.listFields.hasOwnProperty(itemLevel6.field)) {
                                      let option = this.listFields[itemLevel6.field].find(x => x.value === itemLevel6.value)

                                      if (option !== null && option !== undefined) {
                                        option = option.label
                                      }

                                      this.ruleDataTemp.rules[indexLevel6]['value'] = option
                                    }
                                  })
                                } else if (this.listFields.hasOwnProperty(itemLevel5.field)) {
                                  let option = this.listFields[itemLevel5.field].find(x => x.value === itemLevel5.value)


                                  if (option !== null && option !== undefined) {
                                    option = option.label
                                  }

                                  this.ruleDataTemp.rules[indexLevel5]['value'] = option
                                }
                              })
                            } else if (this.listFields.hasOwnProperty(itemLevel4.field)) {
                              let option = this.listFields[itemLevel4.field].find(x => x.value === itemLevel4.value)


                              if (option !== null && option !== undefined) {
                                option = option.label
                              }

                              this.ruleDataTemp.rules[indexLevel4]['value'] = option
                            }
                          })
                        } else if (this.listFields.hasOwnProperty(itemLevel3.field)) {
                          let option = this.listFields[itemLevel3.field].find(x => x.value === itemLevel3.value)


                          if (option !== null && option !== undefined) {
                            option = option.label
                          }

                          this.ruleDataTemp.rules[indexLevel3]['value'] = option
                        }
                      })
                    } else if (this.listFields.hasOwnProperty(itemLevel2.field)) {
                      let option = this.listFields[itemLevel2.field].find(x => x.value === itemLevel2.value)


                      if (option !== null && option !== undefined) {
                        option = option.label
                      }

                      this.ruleDataTemp.rules[indexLevel2]['value'] = option
                    }
                  })
                } else if (this.listFields.hasOwnProperty(itemLevel1.field)) {
                  let option = this.listFields[itemLevel1.field].find(x => x.value === itemLevel1.value)


                  if (option !== null && option !== undefined) {
                    option = option.label
                  }

                  this.ruleDataTemp.rules[indexLevel1]['value'] = option
                }
              })
            } else if (this.listFields.hasOwnProperty(itemLevel0.field)) {
              let option = this.listFields[itemLevel0.field].find(x => x.value === itemLevel0.value)


              if (option !== null && option !== undefined) {
                option = option.label
              }

              this.ruleDataTemp.rules[indexLevel0]['value'] = option
            }

          })
        }

      } catch (e) {
        console.log(e)
      }
    },
    revertBool () {
      if (this.ruleDataTemp !== null) {
        let ruleDataIndex = -1
        if (this.ruleDataTemp.rules.findIndex(x => x.value === true) !== -1) {
          ruleDataIndex = this.ruleDataTemp.rules.findIndex(x => x.value === true)
          this.ruleDataTemp.rules[ruleDataIndex]['value'] = 'Verdadeiro'
        } else if (this.ruleDataTemp.rules.findIndex(x => x.value === false) !== -1) {
          ruleDataIndex = this.ruleDataTemp.rules.findIndex(x => x.value === false)
          this.ruleDataTemp.rules[ruleDataIndex]['value'] = 'Falso'
        } else {
          this.ruleDataTemp.rules.forEach((itemLevel1, indexLevel1) => {
            if (itemLevel1.hasOwnProperty('rules')) {
              if (itemLevel1.rules.findIndex(x => x.value === true) !== -1) {
                ruleDataIndex = itemLevel1.rules.findIndex(x => x.value === true)
                this.ruleDataTemp.rules[indexLevel1].rules[ruleDataIndex]['value'] = 'Verdadeiro'
              } else if (itemLevel1.rules.findIndex(x => x.value === false) !== -1) {
                ruleDataIndex = itemLevel1.rules.findIndex(x => x.value === false)
                this.ruleDataTemp.rules[indexLevel1].rules[ruleDataIndex]['value'] = 'Falso'
              } else {
                itemLevel1.rules.forEach((itemLevel2, indexLevel2) => {
                  if (itemLevel2.hasOwnProperty('rules')) {
                    if (itemLevel2.rules.findIndex(x => x.value === true) !== -1) {
                      ruleDataIndex = itemLevel2.rules.findIndex(x => x.value === true)
                      this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[ruleDataIndex]['value'] = 'Verdadeiro'
                    } else if (itemLevel2.rules.findIndex(x => x.value === false) !== -1) {
                      ruleDataIndex = itemLevel2.rules.findIndex(x => x.value === false)
                      this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[ruleDataIndex]['value'] = 'Falso'
                    } else {
                      itemLevel2.rules.forEach((itemLevel3, indexLevel3) => {
                        if (itemLevel3.rules.findIndex(x => x.value === true) !== -1) {
                          ruleDataIndex = itemLevel3.rules.findIndex(x => x.value === true)
                          this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[ruleDataIndex]['value'] = 'Verdadeiro'
                        } else if (itemLevel3.rules.findIndex(x => x.value === false) !== -1) {
                          ruleDataIndex = itemLevel3.rules.findIndex(x => x.value === false)
                          this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[ruleDataIndex]['value'] = 'Falso'
                        } else {
                          itemLevel3.rules.forEach((itemLevel4, indexLevel4) => {
                            if (itemLevel4.rules.findIndex(x => x.value === true) !== -1) {
                              ruleDataIndex = itemLevel4.rules.findIndex(x => x.value === true)
                              this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[ruleDataIndex]['value'] = 'Verdadeiro'
                            } else if (itemLevel4.rules.findIndex(x => x.value === false) !== -1) {
                              ruleDataIndex = itemLevel4.rules.findIndex(x => x.value === false)
                              this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[ruleDataIndex]['value'] = 'Falso'
                            } else {
                              itemLevel4.rules.forEach((itemLevel5, indexLevel5) => {
                                if (itemLevel5.rules.findIndex(x => x.value === true) !== -1) {
                                  ruleDataIndex = itemLevel5.rules.findIndex(x => x.value === true)
                                  this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[indexLevel5].rules[ruleDataIndex]['value'] = 'Verdadeiro'
                                } else if (itemLevel5.rules.findIndex(x => x.value === false) !== -1) {
                                  ruleDataIndex = itemLevel5.rules.findIndex(x => x.value === false)
                                  this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[indexLevel5].rules[ruleDataIndex]['value'] = 'Falso'
                                } else {
                                  itemLevel5.rules.forEach((itemLevel6, indexLevel6) => {
                                    if (itemLevel6.rules.findIndex(x => x.value === true) !== -1) {
                                      ruleDataIndex = itemLevel5.rules.findIndex(x => x.value === true)
                                      this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[indexLevel5].rules[indexLevel6].rules[ruleDataIndex]['value'] = 'Verdadeiro'
                                    } else if (itemLevel6.rules.findIndex(x => x.value === false) !== -1) {
                                      ruleDataIndex = itemLevel5.rules.findIndex(x => x.value === false)
                                      this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[indexLevel5].rules[indexLevel6].rules[ruleDataIndex]['value'] = 'Falso'
                                    }
                                  })
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  } else if (itemLevel2.value === true) {
                    this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2]['value'] = 'Verdadeiro'
                  } else if (itemLevel2.value === false) {
                    this.ruleDataTemp.rules[indexLevel1].rules[indexLevel2]['value'] = 'Falso'
                  }

                })
              }
            } else if (itemLevel1.value === true) {
              ruleDataIndex = itemLevel1.findIndex(x => x.value === true)
              this.ruleDataTemp.rules[indexLevel1]['value'] = 'Verdadeiro'
            } else if (itemLevel1.value === false) {
              this.ruleDataTemp.rules[indexLevel1]['value'] = 'Falso'
            }
          })
        }
      }
    },
    clearBool () {

      if (this.ruleData !== null && this.ruleData.hasOwnProperty('rules')) {
        let ruleDataIndex = -1
        if (this.ruleData.rules.findIndex(x => x.value === 'Verdadeiro') !== -1) {
          ruleDataIndex = this.ruleData.rules.findIndex(x => x.value === 'Verdadeiro')
          this.ruleData.rules[ruleDataIndex]['value'] = true
        } else if (this.ruleData.rules.findIndex(x => x.value === 'Falso') !== -1) {
          ruleDataIndex = this.ruleData.rules.findIndex(x => x.value === 'Falso')
          this.ruleData.rules[ruleDataIndex]['value'] = false
        } else {
          this.ruleData.rules.forEach((itemLevel1, indexLevel1) => {
            if (itemLevel1.hasOwnProperty('rules')) {
              if (itemLevel1.rules.findIndex(x => x.value === 'Verdadeiro') !== -1) {
                ruleDataIndex = itemLevel1.rules.findIndex(x => x.value === 'Verdadeiro')
                this.ruleData.rules[indexLevel1].rules[ruleDataIndex]['value'] = true
              } else if (itemLevel1.rules.findIndex(x => x.value === 'Falso') !== -1) {
                ruleDataIndex = itemLevel1.rules.findIndex(x => x.value === 'Falso')
                this.ruleData.rules[indexLevel1].rules[ruleDataIndex]['value'] = false
              } else {
                itemLevel1.rules.forEach((itemLevel2, indexLevel2) => {
                  if (itemLevel2.hasOwnProperty('rules')) {
                    if (itemLevel2.rules.findIndex(x => x.value === 'Verdadeiro') !== -1) {
                      ruleDataIndex = itemLevel2.rules.findIndex(x => x.value === 'Verdadeiro')
                      this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[ruleDataIndex]['value'] = true
                    } else if (itemLevel2.rules.findIndex(x => x.value === 'Falso') !== -1) {
                      ruleDataIndex = itemLevel2.rules.findIndex(x => x.value === 'Falso')
                      this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[ruleDataIndex]['value'] = false
                    } else {
                      itemLevel2.rules.forEach((itemLevel3, indexLevel3) => {
                        if (itemLevel3.rules.findIndex(x => x.value === 'Verdadeiro') !== -1) {
                          ruleDataIndex = itemLevel3.rules.findIndex(x => x.value === 'Verdadeiro')
                          this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[ruleDataIndex]['value'] = true
                        } else if (itemLevel3.rules.findIndex(x => x.value === 'Falso') !== -1) {
                          ruleDataIndex = itemLevel3.rules.findIndex(x => x.value === 'Falso')
                          this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[ruleDataIndex]['value'] = false
                        } else {
                          itemLevel3.rules.forEach((itemLevel4, indexLevel4) => {
                            if (itemLevel4.rules.findIndex(x => x.value === 'Verdadeiro') !== -1) {
                              ruleDataIndex = itemLevel4.rules.findIndex(x => x.value === 'Verdadeiro')
                              this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[ruleDataIndex]['value'] = true
                            } else if (itemLevel4.rules.findIndex(x => x.value === 'Falso') !== -1) {
                              ruleDataIndex = itemLevel4.rules.findIndex(x => x.value === 'Falso')
                              this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[ruleDataIndex]['value'] = false
                            } else {
                              itemLevel4.rules.forEach((itemLevel5, indexLevel5) => {
                                if (itemLevel5.rules.findIndex(x => x.value === 'Verdadeiro') !== -1) {
                                  ruleDataIndex = itemLevel5.rules.findIndex(x => x.value === 'Verdadeiro')
                                  this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[indexLevel5].rules[ruleDataIndex]['value'] = true
                                } else if (itemLevel5.rules.findIndex(x => x.value === 'Falso') !== -1) {
                                  ruleDataIndex = itemLevel5.rules.findIndex(x => x.value === 'Falso')
                                  this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[indexLevel5].rules[ruleDataIndex]['value'] = false
                                } else {
                                  itemLevel5.rules.forEach((itemLevel6, indexLevel6) => {
                                    if (itemLevel6.rules.findIndex(x => x.value === 'Verdadeiro') !== -1) {
                                      ruleDataIndex = itemLevel5.rules.findIndex(x => x.value === 'Verdadeiro')
                                      this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[indexLevel5].rules[indexLevel6].rules[ruleDataIndex]['value'] = true
                                    } else if (itemLevel6.rules.findIndex(x => x.value === 'Falso') !== -1) {
                                      ruleDataIndex = itemLevel5.rules.findIndex(x => x.value === 'Falso')
                                      this.ruleData.rules[indexLevel1].rules[indexLevel2].rules[indexLevel3].rules[indexLevel4].rules[indexLevel5].rules[indexLevel6].rules[ruleDataIndex]['value'] = false
                                    }
                                  })
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  } else if (itemLevel2.value === 'Verdadeiro') {
                    this.ruleData.rules[indexLevel1].rules[indexLevel2]['value'] = true
                  } else if (itemLevel2.value === 'Falso') {
                    this.ruleData.rules[indexLevel1].rules[indexLevel2]['value'] = false
                  }

                })
              }
            } else if (itemLevel1.value === 'Verdadeiro') {
              ruleDataIndex = itemLevel1.findIndex(x => x.value === 'Verdadeiro')
              this.ruleData.rules[indexLevel1]['value'] = true
            } else if (itemLevel1.value === 'Falso') {
              this.ruleData.rules[indexLevel1]['value'] = false
            }
          })
        }
      }
    },
    updateRule (args) {
      // const newRule = args.rule

      // for(const rule of newRule.rules) {
      //   console.log(rule)
      // }
    },
    resetAddForm () {
      this.addListData.listFields = [{hash: 0, name: 'Arraste um item', opacity: true}]
      this.listAddObject.name = ''
      this.listAddObject.public = true
      this.listAddObject.owner = {}
    },
    resetEditForm () {
      this.listEditObject.hash = ''
      this.listEditObject.name = ''
      this.listEditObject.public = true
      this.listEditObject.owner = {}
    },
    onEnd (event) {
      if (event.to.getAttribute('data-side') === 'right') {

        let elementHash = ''

        if (event.originalEvent.target.getAttribute('data-hash')) {
          elementHash = event.originalEvent.target.getAttribute('data-hash')
        } else {
          elementHash = event.originalEvent.target.parentElement.getAttribute('data-hash')
        }

        const findModuleFieldIndex = this.addListData.moduleFields.findIndex((item) => item.hash === elementHash)

        if (findModuleFieldIndex > -1) {
          this.addListData.moduleFields.splice(findModuleFieldIndex, 1)
        }
      }
    },
    onEndEdit (event) {
      if (event.to.getAttribute('data-side') === 'right') {

        let elementHash = ''

        if (event.originalEvent.target.getAttribute('data-hash')) {
          elementHash = event.originalEvent.target.getAttribute('data-hash')
        } else {
          elementHash = event.originalEvent.target.parentElement.getAttribute('data-hash')
        }

        const findModuleFieldIndex = this.editListData.moduleFields.findIndex((item) => item.hash === elementHash)

        if (findModuleFieldIndex > -1) {
          this.editListData.moduleFields.splice(findModuleFieldIndex, 1)
        }
      }
    },
    handleSearch (searching) {
      console.log(`The user searched for: ${searching}`)
    },
    handleChangePage (page) {
      console.log(`The user changed the page to: ${page}`)
    },
    handleSort (key, active) {
      console.log(`the user ordered: ${key} ${active}`)
    },
    async addList () {

      this.$vs.loading({type: 'default'})

      let owner = null

      const fieldsList = []

      if (!this.listAddObject.public) {
        if (this.listAddObject.owner && this.listAddObject.owner.hasOwnProperty('hash')) {
          owner = this.listAddObject.owner.hash
        }
      }

      this.addListData.listFields.forEach((item, key) => {
        if (item.hash !== 0) {
          fieldsList.push({
            hash: item.hash,
            index: (key + 1)
          })
        }
      })

      let orderFieldHash = null
      let orderType = null

      if (JSON.stringify(this.listAddObject.orderField) !== '{}') {
        orderFieldHash = this.listAddObject.orderField.hash
      }


      if (['newer', 'older'].includes(this.listAddObject.orderField.hash)) {
        orderFieldHash = this.addListData.moduleFields.find(x => x.name === 'Criado Em')
        orderFieldHash = orderFieldHash.hash

        if (this.listAddObject.orderField.hash === 'newer') {
          orderType = 'DESC'
        } else {
          orderType = 'ASC'
        }
      } else if (JSON.stringify(this.listEditObject.orderType) !== '{}') {
        if (this.listAddObject.orderType !== undefined && this.listAddObject.orderType.hasOwnProperty('value')) {
          orderType = this.listAddObject.orderType.value
        } else {
          orderType = 'DESC'
        }
      }

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_add_application_module_list',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       list: {
      //         name: this.listAddObject.name,
      //         public: this.listAddObject.public,
      //         owner: owner,
      //         fields: fieldsList,
      //         order: {
      //           field_hash: orderFieldHash,
      //           order_type: orderType
      //         }
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_add_application_module_list',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          list: {
            name: this.listAddObject.name,
            public: this.listAddObject.public,
            owner,
            fields: fieldsList,
            order: {
              field_hash: orderFieldHash,
              order_type: orderType
            }
          }
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then(async (responseData) => {

              this.resetAddForm()

              await this.getLists()

              this.addListPopUpActive = !this.addListPopUpActive

              this.$vs.notify({
                title: this.$t('MODULES.operationCompletedTitle'),
                text: responseData.message,
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })

              this.$vs.loading.close()

            })

          } else if (response.status === 400) {
            response.json().then((responseData) => {
              this.$vs.notify({
                title: this.$t('MODULES.hashInvalidTitle'),
                text: responseData.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
            })

            this.$vs.loading.close()
          }
        })
        .catch(e => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async isUuid (value) {
      const reg = /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i

      const isUuid = await value.match(reg)

      if (isUuid === null) {
        return false
      } else {
        return true
      }
    },
    async validateData () {

      if (this.ruleData.hasOwnProperty('rules') && this.ruleData.rules.length > 0) {

        const hashItems = this.ruleData.rules.filter(x => x.label === 'Hash')

        if (hashItems.length > 0) {

          const validateHashs = await this.validateHashItems(hashItems)

          if (!validateHashs) {
            this.$vs.notify({
              title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('MODULES.hashInvalidText'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          } else {
            // var findGroup = this.ruleData.rules.find(x => console.log(x))
            let findGroup = this.ruleData.rules.find(x => x.hasOwnProperty('rules'))

            if (findGroup !== undefined) {
              if (findGroup.hasOwnProperty('rules') && findGroup.rules.length > 0) {

                const hashItems = findGroup.rules.filter(x => x.label === 'Hash')

                if (hashItems.length > 0) {

                  const validateHashs = await this.validateHashItems(hashItems)

                  if (!validateHashs) {
                    this.$vs.notify({
                      title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('MODULES.hashInvalidText'),
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'warning'
                    })

                    return false
                  } else {
                    findGroup = findGroup.rules.find(x => x.hasOwnProperty('rules'))

                    if (findGroup !== undefined) {
                      if (findGroup.hasOwnProperty('rules') && findGroup.rules.length > 0) {

                        const hashItems = findGroup.rules.filter(x => x.label === 'Hash')

                        if (hashItems.length > 0) {

                          const validateHashs = await this.validateHashItems(hashItems)

                          if (!validateHashs) {
                            this.$vs.notify({
                              title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('MODULES.hashInvalidText'),
                              iconPack: 'feather',
                              icon: 'icon-alert-circle',
                              color: 'warning'
                            })

                            return false
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      return true
    },
    async validateHashItems (hashItems) {

      for (let i = 0; i < hashItems.length; i++) {

        const hashItem = hashItems[i]

        if (hashItem !== undefined) {
          const isUuid = await this.isUuid(hashItem['value'])

          if (!isUuid) {

            return false
          }
        }
      }

      return true

    },
    async updateList () {

      this.ruleData = this.$refs.querybuilder.ej2Instances.getRules()

      const dataValid = await this.validateData()

      if (!dataValid) {
        return
      }

      this.$vs.loading({type: 'default'})

      let owner = null

      const fieldsList = []

      if (!this.listEditObject.public) {
        if (this.listEditObject.owner && this.listEditObject.owner.hasOwnProperty('hash')) {
          owner = this.listEditObject.owner.hash
        }
      }

      this.editListData.listFields.forEach((item, key) => {
        if (item.hash !== 0) {
          fieldsList.push({
            hash: item.hash,
            index: (key + 1)
          })
        }
      })

      this.clearBool()

      this.formatDatetimeToSave()

      this.formatDateToSave()

      await this.convertListValues()

      let orderFieldHash = null
      let orderType = null

      if (JSON.stringify(this.listEditObject.orderField) !== '{}') {
        orderFieldHash = this.listEditObject.orderField.hash
      }

      if (['newer', 'older'].includes(this.listEditObject.orderField.hash)) {
        orderFieldHash = this.allModuleFields.find(x => x.name === 'Criado Em')
        orderFieldHash = orderFieldHash.hash

        if (this.listEditObject.orderField.hash === 'newer') {
          orderType = 'DESC'
        } else {
          orderType = 'ASC'
        }
      } else if (JSON.stringify(this.listEditObject.orderType) !== '{}') {
        if (this.listEditObject.orderType !== undefined && this.listEditObject.orderType.hasOwnProperty('value')) {
          orderType = this.listEditObject.orderType.value
        } else {
          orderType = 'DESC'
        }
      }


      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_update_application_module_list',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       list: {
      //         hash: this.listEditObject.hash,
      //         name: this.listEditObject.name,
      //         public: this.listEditObject.public,
      //         owner: owner,
      //         fields: fieldsList,
      //         condition: this.ruleData,
      //         order: {
      //           field_hash: orderFieldHash,
      //           order_type: orderType
      //         }
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_update_application_module_list',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          list: {
            hash: this.listEditObject.hash,
            name: this.listEditObject.name,
            public: this.listEditObject.public,
            owner,
            fields: fieldsList,
            condition: this.ruleData,
            order: {
              field_hash: orderFieldHash,
              order_type: orderType
            }
          }
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then(async (responseData) => {

              if (this.$route.params.listHash !== undefined && this.$route.params.redirectUrl !== undefined) {
                this.editListPopUpActive = !this.editListPopUpActive

                this.$vs.notify({
                  title: this.$t('MODULES.operationCompletedTitle'),
                  text: responseData.message,
                  iconPack: 'feather',
                  icon: 'icon-check-circle',
                  color: 'success'
                })

                this.$vs.loading.close()

                setTimeout(() => {
                  const redirectUrl = atob(this.$route.params.redirectUrl)

                  this.$router.push(`/${  redirectUrl}`).catch()
                }, 300)
              } else {
                this.resetEditForm()

                await this.getLists()

                this.editListPopUpActive = !this.editListPopUpActive

                this.canShow = !this.canShow

                this.$vs.notify({
                  title: this.$t('MODULES.operationCompletedTitle'),
                  text: responseData.message,
                  iconPack: 'feather',
                  icon: 'icon-check-circle',
                  color: 'success'
                })

                this.$vs.loading.close()
              }

            })

          } else if (response.status === 400) {
            response.json().then((responseData) => {
              this.$vs.notify({
                title: this.$t('MODULES.hashInvalidTitle'),
                text: responseData.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
            })

            this.$vs.loading.close()
          }
        })
        .catch(e => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    removeItemAdd (index) {
      const element = this.addListData.listFields[index]
      this.addListData.listFields.splice(index, 1)

      this.addListData.moduleFields.splice(index, 0, element)

      if (this.addListData.moduleFields.length === this.moduleFieldsOriginalLength) {
        this.addListData.listFields.push({hash: 0, name: 'Arraste um item', opacity: true})
      }
    },
    removeItemEdit (index) {
      const element = this.editListData.listFields[index]
      this.editListData.listFields.splice(index, 1)

      this.editListData.moduleFields.splice(index, 0, element)

      if (this.editListData.moduleFields.length === this.moduleFieldsOriginalLength) {
        this.editListData.listFields.push({hash: 0, name: 'Arraste um item', opacity: true})
      }
    },
    confirmDeleteRecord (rowHash) {
      this.rowHashToDelete = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('MODULES.confirmDeletionTitle'),
        text: this.$t('MODULES.confirmDeletionText'),
        accept: this.deleteRecord,
        acceptText: this.$t('MODULES.Delete')
      })
    },
    async deleteRecord () {

      this.$vs.loading({ type: 'default' })

      const requestBody = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        module_token: this.$route.params.moduleHash,
        list_token: this.rowHashToDelete
      }

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_delete_application_module_list',
      //     parameters: requestBody
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'module_management_delete_application_module_list',
        parameters: requestBody
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              await this.getLists()

              this.$vs.loading.close()

              this.$vs.notify({
                title: this.$t('MODULES.operationCompletedTitle'),
                text: response.message,
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.FailedOperation'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToDelete = ''
    },
    async getListDetail (listHash) {

      this.$vs.loading({type: 'default'})

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_get_application_module_list_detail',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       list_token: listHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_get_application_module_list_detail',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          list_token: listHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.editListData.listFields = []
              this.editListData.moduleFields = []

              this.listEditObject.hash = listHash
              this.listEditObject.name = responseData.list.name
              this.listEditObject.owner = responseData.list.owner
              this.listEditObject.public = true
              const orderField = responseData.list.order_field
              const orderFieldType = responseData.list.order_field_type

              // [{name: 'Ascendente', value: 'ASC'}, {name: 'Descendente', value: 'DESC'}]

              if (orderField !== null && orderFieldType !== null) {

                if (orderField.name === 'Criado Em') {
                  if (orderFieldType === 'ASC') {
                    this.listEditObject.orderField = {
                      hash: 'older',
                      name: this.$t('MODULES.oldestRecord')
                    }
                  } else {
                    this.listEditObject.orderField = {
                      hash: 'newer',
                      name: this.$t('MODULES.mostRecentRecord')
                    }
                  }
                } else {
                  this.listEditObject.orderField = orderField

                  if (orderFieldType === 'ASC') {
                    this.listEditObject.orderType = {name: 'Ascendente', value: 'ASC'}
                  } else {
                    this.listEditObject.orderType = {name: 'Descendente', value: 'DESC'}
                  }
                }
              }

              this.ruleDataTemp = responseData.list.condition_payload

              if (this.ruleDataTemp !== null) {
                this.changeListHashToListValue()
                this.revertDatetime()
                this.revertDate()
                this.revertBool()
              }

              // this.ruleData = this.ruleDataTemp

              this.canShow = true

              responseData.list.fields.forEach((item) => {
                this.editListData.listFields.push({
                  hash: item.hash,
                  name: item.name
                })
              })

              this.editListData.listFields.sort((a, b) => {
                if (a.index > b.index) {
                  return 1
                }

                if (a.index < b.index) {
                  return -1
                }

                return 0
              })

              this.editListData.moduleFields = this.moduleFields

              this.editListData.listFields.forEach((item) => {
                const itemIndex = this.editListData.moduleFields.findIndex((listFieldItem) => listFieldItem.hash === item.hash)

                if (itemIndex > -1) {
                  this.editListData.moduleFields.splice(itemIndex, 1)
                }
              })

              setTimeout(() => {
                this.$refs.querybuilder.ej2Instances.setRules(this.ruleDataTemp)
                this.setListValues()
                // this.$refs.querybuilder.ej2Instances.notifyChange(e.itemData.value, e.element)
                this.editListPopUpActive = !this.editListPopUpActive

                // document.querySelector('.e-rule-filter').style.width = '33%'

                this.$vs.loading.close()
              }, 300)

            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('MODULES.hashInvalidTitle'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getUsers () {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_users',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_users',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.userOptions = []

              responseData.users.forEach((item) => {
                const userObject = {
                  hash: item.hash,
                  name: item.name
                }

                this.userOptions.push(userObject)
              })

              this.userOptions.sort((a, b) => {
                if (a.name > b.name) {
                  return 1
                }

                if (a.name < b.name) {
                  return -1
                }

                return 0
              })
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('MODULES.hashInvalidTitle'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getLists () {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_get_application_module_lists',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_get_application_module_lists',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.lists = []

              responseData.lists.forEach((item) => {
                this.listFieldsObject[item.hash] = item.fields
              })

              this.lists = responseData.lists
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('MODULES.hashInvalidTitle'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getModuleFields () {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_get_application_module_fields',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_get_application_module_fields',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {
              responseData.module.payload.forEach((blockItem) => {
                blockItem.fields.forEach((fieldItem) => {
                  if (fieldItem.type_id !== 21 && fieldItem.type_id !== 22 && !(fieldItem.type_id === 23 && fieldItem.core)) {
                    const fieldObject = {
                      hash: fieldItem.hash,
                      name: fieldItem.title,
                      type: fieldItem.type_id,
                      options: fieldItem.options,
                      core: fieldItem.core
                    }

                    this.fieldTypesObject[fieldItem.hash] = fieldItem.type_id

                    this.allModuleFields.push(fieldObject)

                    this.allModuleFields.sort((a, b) => {
                      if (a.name < b.name) return -1
                      if (a.name > b.name) return 1
                      return 0
                    })

                    if (fieldItem.type_id === 24 || fieldItem.type_id === 25 || fieldItem.type_id === 29 || fieldItem.type_id === 30) {

                      const clearOptions = []

                      fieldItem.options.forEach((item, key) => {

                        if (item.hasOwnProperty('groupLevel') && item.groupLevel === 2) {
                          clearOptions.push({label: item.label, value: item.value})
                        } else if (!item.hasOwnProperty('groupLevel')) {
                          clearOptions.push({label: item.label, value: item.value})
                        }
                      })

                      this.listFields[fieldItem.hash] = clearOptions
                    } else if (fieldItem.type_id === 12) {
                      this.hasDateFields = true
                      this.dateFields.push(fieldItem.hash)
                    } else if (fieldItem.type_id == 13) {
                      this.hasDatetimeFields = true
                      this.datetimeFields.push(fieldItem.hash)
                    }

                    this.moduleFields.push(fieldObject)
                    this.addListData.moduleFields.push(fieldObject)
                  }
                })
              })

              setApplicationLocalStorageItem('listFields', JSON.stringify(this.listFields))

              this.moduleFieldsOriginalLength = this.moduleFields.length
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('MODULES.hashInvalidTitle'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    }
  },
  async created () {
    this.$vs.loading({ type: 'default' })
    await this.getUsers()
    await this.getLists()
    await this.getModuleFields()
    if (this.$route.params.listHash !== undefined && this.$route.params.redirectUrl !== undefined) {
      this.getListDetail(this.$route.params.listHash)
    }
    this.$vs.loading.close()
  }
}
</script>

<style lang="scss" scoped>

  @import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-vue-querybuilder/styles/material.css";

.vs-popup {
  width: 1200px!important;
  height: 600px!important;
}


.demo-chip {
  opacity: 0.5!important;
}

.e-rule-filter {
  width: 33%!important;
}

// .e-rule-filter {
//   width: 33%!important;
// }

// .e-rule-operator.e-operator {
//   width: 33%!important;
// }

// .e-input-group.e-control-wrapper.e-ddl.e-lib.e-keyboard.e-valid-input {
//   width: 31%!important;
// }

// .field-type-select >>> .vs__dropdown-menu {
//   height: 168px !important;
// }
</style>

<style>

  /* .e-rule-filter {
    width: 33%!important;
  }

  .e-rule-operator.e-operator {
    width: 33%!important;
  }

  .e-input-group.e-control-wrapper.e-ddl.e-lib.e-keyboard.e-valid-input {
    width: 31%!important;
  } */

</style>
